import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import VueCookies from "vue-cookies";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    protocol: window.PANEL_HTTP_PROTOCOL,
    host: window.PANEL_HOST,
    apiHost: window.PANEL_API_HOST,
    port: window.PANEL_PORT,
    yandexMetricToken: window.PANEL_YANDEX_METRICS_TOKEN,
    protocolWS: window.PANEL_SOCKETS_PROTOCOL,
    apiAdminPanelV1: "/api/v1/adminPanel",
    apiAdminPanelV2: "/api/v2/adminPanel",
    apiAdminPanelV3: "/api/v3/adminPanel",
    apiAdminPanelV4: "/api/v4/adminPanel",
    apiAdminPanelV5: "/api/v5",
    apiAdminPanelV7: "/api/v7",

    apiNotifications: "/api/notifications",
    apiMobileV1: "/api/v1/mobile",
    apiMobileV4: "/api/v4/mobile",
    adminPanelKeyCookie: `ap_${window.PANEL_APP_ID}`,
    secretKeyCookie: window.PANEL_APP_ID,
    user: {},
    mailTo: "#{app-mail-to}",
    error: false,
    errorText: "",
    info: false,
    infoText: "",
    success: false,
    successText: "",
  },
  getters: {
    apiAdminPanelV1: (state) => {
      return (
        state.protocol +
        "://" +
        state.apiHost +
        ":" +
        state.port +
        state.apiAdminPanelV1
      );
    },
    yandexMetricTokenGetter: (state) => {
      return "OAuth " + state.yandexMetricToken;
    },
    apiAdminPanelV2: (state) => {
      return (
        state.protocol +
        "://" +
        state.apiHost +
        ":" +
        state.port +
        state.apiAdminPanelV2
      );
    },
    apiAdminPanelV3: (state) => {
      return (
        state.protocol +
        "://" +
        state.apiHost +
        ":" +
        state.port +
        state.apiAdminPanelV3
      );
    },
    apiAdminPanelV4: (state) => {
      return (
        state.protocol +
        "://" +
        state.apiHost +
        ":" +
        state.port +
        state.apiAdminPanelV4
      );
    },
    apiAdminPanelV5: (state) => {
      return (
        state.protocol +
        "://" +
        state.apiHost +
        ":" +
        state.port +
        state.apiAdminPanelV5
      );
    },
    apiAdminPanelV7: (state) => {
      return (
        state.protocol +
        "://" +
        state.apiHost +
        ":" +
        state.port +
        state.apiAdminPanelV7
      );
    },
    apiNotifications: (state) => {
      return (
        state.protocol +
        "://" +
        state.apiHost +
        ":" +
        state.port +
        state.apiNotifications
      );
    },
    apiMobileV1: (state) => {
      return (
        state.protocol +
        "://" +
        state.apiHost +
        ":" +
        state.port +
        state.apiMobileV1
      );
    },
    apiMobileV4: (state) => {
      return (
        state.protocol +
        "://" +
        state.apiHost +
        ":" +
        state.port +
        state.apiMobileV4
      );
    },
    socketUrlReception: (state) => {
      return "ws" + "://" + "localhost" + ":" + "3005";
    },
    socketUrlInternetReception: (state) => {
      return (
        state.protocolWS +
        "://" +
        state.apiHost +
        ":" +
        state.port +
        "/reception"
      );
    },
    baseURL: (state) => {
      return state.protocol + "://" + state.apiHost + ":" + state.port;
    },
    keyWSReception: (state) => {
      return "1234";
    },
    wsURL: (state) => {
      return state.protocolWS + "://" + state.apiHost;
    },

    wsURLSocketNative: (state) => {
      return (
        state.protocolWS +
        "://" +
        state.apiHost +
        ":" +
        state.port +
        "/webSocket"
      );
    },
    wsChatURL: (state) => {
      return (
        state.protocolWS +
        "://" +
        state.apiHost +
        ":" +
        state.port +
        "/chat/webSocket"
      );
    },
    adminPanelHeaderAuth: (state) => {
      return "Bearer " + VueCookies.get(state.adminPanelKeyCookie);
    },
    socketAdminKey: (state) => {
      return VueCookies.get(state.adminPanelKeyCookie);
    },
    user: (state) => {
      return state.user;
    },
    mailTo: (state) => {
      return state.mailTo;
    },
    visiblePage: (state) => (key) => {
      const newItem = state.user.sections.filter((i) => i.key == key);
      let val = false;
      if (newItem[0]) {
        newItem[0].accesses.forEach((element) => {
          if (element.value) {
            val = true;
          }
        });
      }
      return val;
    },
    editRoleUser: (state) => (val) => {
      const neededObj = state.user.sections.filter((i) => i.key == val);
      const result = neededObj[0].accesses.filter((i) => {
        if (i.key == "edit" && i.value) {
          return i;
        }
      });
      if (result[0]) {
        return true;
      } else {
        return false;
      }
    },
    adminRoleUser: (state) => (val) => {
      const neededObj = state.user.sections.filter((i) => i.key == val);
      const result = neededObj[0].accesses.filter((i) => {
        if (i.key == "super_admin" && i.value) {
          return i;
        }
      });
      if (result[0]) {
        return true;
      } else {
        return false;
      }
    },
  },
  mutations: {
    userSet(state, user) {
      state.user = user;
    },
    errorSet(state, alertObj) {
      const resetState = (type) => {
        state[type] = false;
      };
      if (typeof alertObj === "object") {
        const { key, text, type } = alertObj;
        state[`${type}Text`] = text;
        state[type] = key;
        setTimeout(resetState, 4000, type);
      } else {
        state.error = true;
        setTimeout(resetState, 4000, "error");
      }
    },
    errorTextSet(state, err) {
      if (err?.response?.data?.localize?.ru) {
        state.errorText = err.response.data.localize.ru;
      } else if (err && typeof err) {
        state.errorText = err;
      } else {
        state.errorText = "Неизвестная ошибка или проблема с подключением";
      }
    },
  },
  actions: {
    authorizationAdminPanel: function (context) {
      return axios
        .get(context.getters.apiAdminPanelV5 + "/auth/check", {
          headers: {
            authorization: context.getters.adminPanelHeaderAuth,
            "secret-key": context.state.secretKeyCookie,
          },
        })
        .then((res) => {
          if (!res.data.user.isBlocked) {
            context.commit("userSet", res.data.user);
            return true;
          } else {
            return false;
          }
        })
        .catch(() => {
          return false;
        });
    },
  },
  modules: {},
});
